import { render, staticRenderFns } from "./PersonajesDestacados.vue?vue&type=template&id=074ff57a&scoped=true"
import script from "./PersonajesDestacados.vue?vue&type=script&lang=ts"
export * from "./PersonajesDestacados.vue?vue&type=script&lang=ts"
import style0 from "./PersonajesDestacados.vue?vue&type=style&index=0&id=074ff57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074ff57a",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QImg,QToolbar,QBtn,QDrawer,QScrollArea,QList,QItem,QItemSection,QItemLabel,QCard,QVideo,QCardSection,QAvatar,QIcon});qInstall(component, 'directives', {ClosePopup});
